import { dataSquareRotationSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSquareRotationSolid = /*#__PURE__*/createIcon(dataSquareRotationSolid)
export default IconSquareRotationSolid
